"use strict";
/** @module models */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Device = exports.PushNotification = exports.MinimalDevice = void 0;
var cerealParse_1 = require("../cerealParse");
/**
 * Class representing a minimal device and providing a static parse method.
 */
var MinimalDevice = /** @class */ (function () {
    function MinimalDevice(id, name) {
        this.id = id;
        this.name = name;
    }
    /**
     * Parse object potentially representing a MinimalDevice.
     * @param o
     * @return Parse result
     */
    MinimalDevice.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new MinimalDevice(cerealParse_1.ParseUtils.getString(o, 'id'), cerealParse_1.ParseUtils.getString(o, 'name')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid MinimalDevice Model: ".concat(e.message));
        }
    };
    return MinimalDevice;
}());
exports.MinimalDevice = MinimalDevice;
var PushNotification = /** @class */ (function () {
    function PushNotification(id, timestamp, type, alertTone, message, ackTs) {
        this.id = id;
        this.timestamp = timestamp;
        this.type = type;
        this.alertTone = alertTone;
        this.message = message;
        this.ackTs = ackTs;
    }
    PushNotification.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new PushNotification(cerealParse_1.ParseUtils.getString(o, 'id'), new Date(cerealParse_1.ParseUtils.getNumber(o, 'ts') * 1000), cerealParse_1.ParseUtils.getString(o, 'type'), cerealParse_1.ParseUtils.getString(o, 'alertTone'), cerealParse_1.ParseUtils.getString(o, 'message'), cerealParse_1.ParseUtils.getUNIXTimestampDateOrNull(o, 'ackTs')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid PushNotification Model: ".concat(e.message));
        }
    };
    return PushNotification;
}());
exports.PushNotification = PushNotification;
var Device = /** @class */ (function () {
    function Device(id, name, hardwareId, type, lastInteractionTime, appVersion, canUseForLocation, useForLocation, receivePush, apiKey, pushToken) {
        this.id = id;
        this.name = name;
        this.hardwareId = hardwareId;
        this.type = type;
        this.lastInteractionTime = lastInteractionTime;
        this.appVersion = appVersion;
        this.canUseForLocation = canUseForLocation;
        this.useForLocation = useForLocation;
        this.receivePush = receivePush;
        this.apiKey = apiKey;
        this.pushToken = pushToken;
    }
    Device.prototype.supportsNotificationAck = function () {
        return this.type == 'android';
    };
    Device.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new Device(cerealParse_1.ParseUtils.getString(o, 'id'), cerealParse_1.ParseUtils.getString(o, 'name'), cerealParse_1.ParseUtils.getString(o, 'hardwareId'), cerealParse_1.ParseUtils.getStringOrNull(o, 'deviceType'), new Date(cerealParse_1.ParseUtils.getNumber(o, 'lastInteractionTime') * 1000), cerealParse_1.ParseUtils.getStringOrNull(o, 'appVersion'), cerealParse_1.ParseUtils.getBoolean(o, 'canUseForLocation'), cerealParse_1.ParseUtils.getBoolean(o, 'useForLocation'), cerealParse_1.ParseUtils.getBoolean(o, 'receivePush'), cerealParse_1.ParseUtils.getString(o, 'apiKey'), cerealParse_1.ParseUtils.getStringOrNull(o, 'pushToken')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid Device Model: ".concat(e.message));
        }
    };
    return Device;
}());
exports.Device = Device;
//# sourceMappingURL=device.js.map